import { downgradeComponent } from '@angular/upgrade/static';
import { NgxZeroStateComponent } from '@go-modules/components/zero-state/zero-state.component';
import * as angular from 'angular';

// TODO - remove when rubricFeedbackViewer STAB-748, coursePaymentWall STAB-615
export const ngxZeroStateModule = angular.module('ngxZeroStateModule', [])
	.directive('ngxZeroState', downgradeComponent({component: NgxZeroStateComponent}))
	.name;
